import types from "../../actions/types"

export default function processing(state, action) {
  switch (action.type) {
    case types.processingStart: {
      return {
        ...state,
        process: {
          type: action.processType,
          task: action.task,
        },
      }
    }
    case types.processingComplete:
      if (
        state.process &&
        state.process.type === action.processType &&
        state.process.task === action.task
      ) {
        return {
          ...state,
          process: null,
        }
      }
      return state
    default:
      return state
  }
}
